import { combineReducers, createSelector, props } from '@ngrx/store';
import { CoreState } from '@app/core/store/core.slice';
import {
  initializeLoadStateWithoutData,
  LoadState,
} from '@app/core/store/_prototypes/action-reducers/state/load.state';
import { createLoadActions } from '@app/core/store/_prototypes/action-reducers/actions/load.actions';
import { createLoadReducer } from '@app/core/store/_prototypes/action-reducers/reducers/load.reducers';
import { loadSelector } from '@app/core/store/_prototypes/action-reducers/selectors/load.selectors';
import { ClientConfig } from '@app/core/types/config/config.types';

const PREFIX = '[HOME]';
export const stateKey = 'home';

export interface HomeState {
  clientConfig: LoadState<Record<never, never>, ClientConfig>;
}
export const getClientConfig = createLoadActions<Record<string, never>, ClientConfig>(
  `${PREFIX} getClientConfig`,
  props<Record<string, never>>()
);
export const homeReducers = combineReducers<HomeState>({
  clientConfig: createLoadReducer(
    initializeLoadStateWithoutData<Record<string, never>, ClientConfig>(),
    getClientConfig
  ),
});

const stateSelector = createSelector(
  (state: CoreState) => state,
  (state: CoreState) => state[stateKey] as HomeState
);
export const clientConfigStateSelector = createSelector(stateSelector, (state) => state.clientConfig);
export const clientConfigApplicableState = loadSelector(clientConfigStateSelector);

export const employeeSelector = createSelector(stateSelector, (state) => state.clientConfig.data?.employee);

export const savedJobsConfigSelector = createSelector(stateSelector, (state) => state.clientConfig.data?.job?.savedJobs);

export const chatBotKnowledgeConfigSelector = createSelector(
  stateSelector,
  (state) => state?.clientConfig?.data?.chatBot?.knowledge
);

export const timeRegistrationConfigSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.timeRegistration
);

export const showWorkedHoursSelector = createSelector(stateSelector, (state) => {
  return {
    showWorkedHoursPastWeeks: state.clientConfig.data?.work.workedHoursPastWeeks.isVisible,
    showWorkedHoursLastWeek: state.clientConfig.data?.work.workedHoursLastWeek.isVisible,
  };
});

export const showNextPaymentDateSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.work.nextPaymentDate.isVisible
);

export const showHolidayRequestStartTimeSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.holidayRequest.startTime.isVisible
);

export const showHolidayRequestEndTimeSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.holidayRequest.endTime.isVisible
);

export const showHolidayRequestEntireDaySelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.holidayRequest.entireDay.isVisible
);

export const showHolidayRequestUserReservationSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.holidayRequest.useReservations.isVisible
);

export const showHolidayRequestRemarkSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.holidayRequest.remark.isVisible
);

export const applicationLanguageSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.applicationLanguage
);

export const eventCalendarConfigSelector = createSelector(
  stateSelector,
  (state) => state.clientConfig.data?.eventCalendar
);